import { Transition } from '@headlessui/react';
import type { PropsWithChildren } from 'react';
import type React from 'react';
import { Fragment } from 'react';

interface IProps extends PropsWithChildren {
  show: boolean;
}

export const Spinimate: React.FC<IProps> = ({ children, show }) => {
  return (
    <Transition
      as={Fragment}
      show={show}
      enter="transform transition duration-[400ms]"
      enterFrom="opacity-0 rotate-[-120deg] scale-50"
      enterTo="opacity-100 rotate-0 scale-100"
      leave="transform duration-200 transition ease-in-out"
      leaveFrom="opacity-100 rotate-0 scale-100 "
      leaveTo="opacity-0 scale-95 "
    >
      {children}
    </Transition>
  );
};
